const Html = {
	hasSomeParentTheClass: (selector, classname) => {
		let element = selector;
		if (typeof element === 'string') {
			element = document.querySelector(selector);
		}
		if (typeof element.className === 'string' && element.className.split(' ').indexOf(classname) >= 0) return true;
		return element.parentNode && Html.hasSomeParentTheClass(element.parentNode, classname);
	},

	addClass: (selector, className) => {
		let element = selector;
		if (typeof element === 'string') {
			element = document.querySelector(selector);
		}
		if (element !== null) {
			element.classList.add(className);
		}
	},
	hasClass: (selector, className) => {
		let element = selector;
		if (typeof element === 'string') {
			element = document.querySelector(selector);
		}
		if (element !== null) {
			return element.classList.contains(className);
		}
		return false;
	},
	removeClass: (selector, className) => {
		let element = selector;
		if (typeof element === 'string') {
			element = document.querySelector(selector);
		}
		if (element !== null) {
			element.classList.remove(className);
		}
	},
	getWindowSize: () => {
		return {
			width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
			height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
		}
	},
	getElementSize: (selector, props = false) => {
		let element = selector;
		if (typeof selector === 'string') {
			element = document.querySelector(selector);
		}
		if (element !== null) {
			const size = element.getBoundingClientRect();
			if (props === false) {
				return size;
			}
			if (typeof size[props] !== 'undefined') {
				return parseInt(size[props], 10);
			}

			return 0;
		}
	},
	getElementCss: (selector, props = false) => {
		let element = selector;
		if (typeof selector === 'string') {
			element = document.querySelector(selector);
		}
		if (element !== null) {
			const style = getComputedStyle(element);
			if (props === false) {
				return style;
			}
			if (typeof style[props] !== 'undefined') {
				return parseInt(style[props], 10);
			}

			return 0;
		}
	}
}
export default Html;
